import { render, staticRenderFns } from "./SynchroWidget.vue?vue&type=template&id=fbef9f2a&scoped=true"
import script from "./SynchroWidget.vue?vue&type=script&lang=js"
export * from "./SynchroWidget.vue?vue&type=script&lang=js"
import style0 from "./SynchroWidget.vue?vue&type=style&index=0&id=fbef9f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbef9f2a",
  null
  
)

export default component.exports